import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Taps, Tooltip } from '@ds'
import { usePrologue, usePrologueActions } from '@store'

import styles from './Tooltip.module.scss'

const SHOW_TOOLTIP_TIME = 4000

type Props = {
  className?: string
}

export const TooltipTaps = ({ className }: Props) => {
  const [showTapTooltip, setShowTapTooltip] = useState(false)

  const { showTooltips } = usePrologue()
  const { t } = useTranslation()
  const { setShowTooltips } = usePrologueActions()

  useEffect(() => {
    if (showTooltips) {
      setShowTapTooltip(true)
      const timeout = setTimeout(() => {
        setShowTapTooltip(false)
        setShowTooltips(false)
      }, SHOW_TOOLTIP_TIME)

      return () => clearTimeout(timeout)
    }
  }, [showTooltips])

  return (
    <>
      <Tooltip
        tooltipId="quest-tap-tooltip"
        isOpen={showTapTooltip}
        position="top"
        tooltipContent={
          <div className={styles.tooltipFont}>{t('prologue.tapsTooltip')}</div>
        }
      >
        <Taps className={className} />
      </Tooltip>
    </>
  )
}
